import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/user/cdkey/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/user/cdkey/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/user/cdkey/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/user/cdkey/submit',
    method: 'post',
    data: row
  })
}

